import { FormInput } from '../input/InputStyle';
import { ReactNode } from 'react';
import { Autocomplete, CircularProgress } from '@material-ui/core';
import FormLabelComponent from '../input/FormLabel.component';

export interface SelectInterface<T> {
  title: string;
  onChange(event: any, newValue: any): void;
  value: T;
  disabled?: boolean;
  onClick?(event: React.MouseEvent<HTMLElement, MouseEvent>): void;
  children?: ReactNode;
  request?: boolean;
  id?: any;
  data: IOption[];
  multiple?: boolean;
  required?: boolean;
  placeholder?: string;
  xs?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | undefined;
  sm?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | undefined;
  md?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | undefined;
  lg?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | undefined;
  margin?: string;
  onInputChange?: (value: string) => void;
  onClose?: () => void;
}

export interface IOption {
  label: string;
  value: any;
}

export default function SelectSearch({
  title,
  onChange,
  id,
  value,
  disabled,
  required,
  data,
  request,
  multiple,
  xs,
  sm,
  md,
  lg,
  placeholder,
  margin,
  onInputChange,
}: SelectInterface<any>) {
  return (
    <FormLabelComponent
      margin={margin || '0 0 0 0'}
      title={title}
      xs={xs || 12}
      sm={sm || 6}
      md={md}
      lg={lg}
      required={required}
    >
      <Autocomplete
        id={id}
        filterOptions={(option) => option}
        size='small'
        multiple={multiple}
        limitTags={multiple ? 2 : 0}
        disableCloseOnSelect={multiple}
        options={data}
        getOptionLabel={(option: IOption) => option.label}
        isOptionEqualToValue={(option: IOption, value: any) =>
          option.label.toUpperCase() === value.label.toUpperCase()
        }
        filterSelectedOptions
        loading={request}
        onChange={onChange}
        clearOnBlur={false}
        disabled={disabled}
        clearText='Limpar'
        closeText='Fechar'
        loadingText='Carregando...'
        noOptionsText='Não encontrado'
        value={value}
        onInputChange={(
          event: React.SyntheticEvent,
          value: string,
          reason: string
        ) => {
          onInputChange && onInputChange(value);
        }}
        renderInput={(params) => (
          <FormInput
            {...params}
            placeholder={placeholder || ''}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {request ? (
                    <CircularProgress color='inherit' size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
          />
        )}
      />
    </FormLabelComponent>
  );
}
